/**
 * CouponListPresenter
 * --
 */
import React, { useEffect } from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  ExpandableContainer,
  Table,
  Pagination,
  ModalLayout,
  InputFormTable,
} from 'components';
import {
  Button,
  DatePicker,
  Input,
  Radio,
  Select,
  Tag,
  Table as AntTable,
  Space,
  Modal,
  InputNumber,
} from 'antd';
import MessageAlert, { getDateRange } from 'utils';
import moment from 'moment';
import Formatter from 'utils/Formatter';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { CouponInfoForm, CouponProductTable } from '../components';
import { SearchOutlined } from '@ant-design/icons';
import { ACCOUNT_STATUS } from 'constants/UserContants';
const COUPON_TYPE = {
  ALL: { label: '전체 할인', color: 'purple' },
  MENU: { label: '메뉴 할인', color: 'green' },
  MD: { label: 'MD 할인', color: 'volcano' },
  DESSERT: { label: '디저트 할인', color: 'lime' },
  PRODUCT: { label: '상품 할인', color: 'blue' },
};
const VOUCHER_TYPE = {
  EXCHANGE: { label: '교환권', color: 'purple' },
  PERCENT_DISCOUNT: { label: '비율할인', color: 'green' },
  AMOUNT_DISCOUNT: { label: '금액할인', color: 'volcano' },
};
const IS_VALUE = {
  Y: {
    IS_SHOW: { label: 'O', color: 'blue' },
    IS_USED: { label: 'O', color: 'blue' },
  },
  N: {
    IS_SHOW: { label: 'X', color: 'red' },
    IS_USED: { label: 'X', color: 'red' },
  },
};
const CouponListPresenter = (props) => {
  const {
    // auth,
    couponData,
    filteredCouponData,
    storeData,
    menuData,
    userData,
    selectCouponValue,
    selectPolicyValue,
    storeValue,
    menuValue,
    userValue,
    setSelectCouponValue,
    setSelectPolicyValue,
    setStoreValue,
    setMenuValue,
    onStoreChecked,
    isCheckedStoreAll,
    onStoreCheckedAll,
    onMenuChecked,
    isCheckedMenuAll,
    onMenuCheckedAll,
    onUserChecked,
    isCheckedUserAll,
    onUserCheckedAll,
    modalType,
    // modalData,
    isOpened,
    onOpen,
    onChange,
    onSubmit,
    // onDelete,
    /* --- 검색 관련 props 추가 --- */
    searchParams,
    setSearchParams,
    sideSearchParams,
    setSideSearchParams,
    handleSearch,
    handleReset,
    // NOTE -
    onSelect,
    categories,
    shops,
    setUserValue,
    grades,
    currentPage,
    setCurrentPage,
  } = props;
  /* ===== ROUTE ===== */

  const ITEMS_PER_PAGE = 10; // 페이지 당 항목 수
  const [visible, setVisible] = React.useState(false);
  const navigate = useNavigate();
  const today = new Date();
  const [modalPosition, setModalPosition] = React.useState({ x: 0, y: 0 });
  // console.log(Formatter.dateToUnix(today));
  /* ===== PROPS ===== */
  // console.log(couponData);
  // console.log(selectCouponValue);
  // console.log(selectPolicyValue);
  // console.log(menuValue);
  // console.log(storeValue);
  /* ===== STATE ===== */
  const [searchText, setSearchText] = React.useState('');
  const [searchedColumn, setSearchedColumn] = React.useState('');
  const [newCouponData, setNewCouponData] = React.useState('');
  const searchInput = React.useRef(null);

  const [issuedNumb, setIssuedNumb] = React.useState(1);

  const handleTableSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleTableReset = (clearFilters, confirm) => {
    setSearchText('');
    confirm();
    clearFilters();
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`검색어를 입력해주세요`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleTableSearch(selectedKeys, confirm, dataIndex)
          }
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleTableSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            검색
          </Button>
          <Button
            onClick={() =>
              clearFilters && handleTableReset(clearFilters, confirm)
            }
            size="small"
            style={{
              width: 90,
            }}
          >
            초기화
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ?.toString()
        ?.toLowerCase()
        ?.includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) => text,
  });

  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 140,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const formItem = [
    {
      label: '검색어',
      direction: 'column',
      form: [
        {
          input: (
            <>
              <Select
                size="large"
                value={searchParams.searchField}
                options={[
                  { label: '쿠폰명', value: 'coupon_name' },
                  { label: '쿠폰코드', value: 'coupon_code' },
                ]}
                style={{ ...styles.form.input.large }}
                onChange={(value) =>
                  setSearchParams((prev) => ({ ...prev, searchField: value }))
                }
              />
              <Input
                size="large"
                placeholder="검색어를 입력해주세요"
                style={{ ...styles.form.input.large, width: 350 }}
                value={searchParams.searchKeyword}
                onChange={(e) =>
                  setSearchParams((prev) => ({
                    ...prev,
                    searchKeyword: e.target.value,
                  }))
                }
              />
            </>
          ),
        },
      ],
    },
    {
      label: '기간',
      form: [
        {
          input: (
            <Button
              size="large"
              style={{ ...styles.form.button }}
              onClick={() => handlePresetClick(0)}
            >
              오늘
            </Button>
          ),
        },
        {
          input: (
            <Button
              size="large"
              style={{ ...styles.form.button }}
              onClick={() => handlePresetClick(7)}
            >
              1주일
            </Button>
          ),
        },
        {
          input: (
            <Button
              size="large"
              style={{ ...styles.form.button }}
              onClick={() => handlePresetClick(30)}
            >
              1개월
            </Button>
          ),
        },
        {
          input: (
            <Button
              size="large"
              style={{ ...styles.form.button }}
              onClick={() => handlePresetClick(90)}
            >
              3개월
            </Button>
          ),
        },
        {
          input: (
            <Button
              size="large"
              style={{ ...styles.form.button }}
              onClick={() => handlePresetClick(1)}
            >
              전체
            </Button>
          ),
        },
        {
          input: (
            <>
              <DatePicker
                size="large"
                format="YYYY-MM-DD"
                placeholder="시작일"
                style={{ ...styles.form.date }}
                value={
                  searchParams.searchCustomDateRange.start
                    ? dayjs(searchParams.searchCustomDateRange.start)
                    : null
                }
                onChange={(date) =>
                  setSearchParams((prev) => ({
                    ...prev,
                    searchCustomDateRange: {
                      ...prev.searchCustomDateRange,
                      start: date ? date.toDate() : null,
                    },
                  }))
                }
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <DatePicker
                size="large"
                format="YYYY-MM-DD"
                placeholder="종료일"
                style={{ ...styles.form.date }}
                value={
                  searchParams.searchCustomDateRange.end
                    ? dayjs(searchParams.searchCustomDateRange.end)
                    : null
                }
                onChange={(date) =>
                  setSearchParams((prev) => ({
                    ...prev,
                    searchCustomDateRange: {
                      ...prev.searchCustomDateRange,
                      end: date ? date.toDate() : null,
                    },
                  }))
                }
              />
            </>
          ),
        },
      ],
    },
    {
      label: '지급유형',
      form: [
        {
          input: (
            <Radio.Group
              value={searchParams.searchPaymentType}
              onChange={(e) =>
                setSearchParams((prev) => ({
                  ...prev,
                  searchPaymentType: e.target.value,
                }))
              }
            >
              <Radio value={'ALL'}>전체</Radio>
              <Radio value={'MANUAL'}>수동</Radio>
              <Radio value={'AUTOMATIC'}>자동</Radio>
              <Radio value={'DOWNLOAD'}>다운로드</Radio>
              <Radio value={'STAMP'}>스탬프</Radio>
            </Radio.Group>
          ),
        },
      ],
    },
    {
      label: '쿠폰 타입',
      form: [
        {
          input: (
            <Radio.Group
              value={searchParams.searchCouponType}
              onChange={(e) =>
                setSearchParams((prev) => ({
                  ...prev,
                  searchCouponType: e.target.value,
                }))
              }
            >
              <Radio value={null}>전체</Radio>
              <Radio value={'ALL'}>전체 할인</Radio>
              <Radio value={'MENU'}>메뉴 할인</Radio>
              <Radio value={'MD'}>MD 할인</Radio>
              <Radio value={'DESSERT'}>디저트 할인</Radio>
              <Radio value={'PRODUCT'}>상품 할인</Radio>
            </Radio.Group>
          ),
        },
      ],
    },
  ];

  const policyform = [
    {
      key: 'discount_rate',
      label: '할인 설정',
      form: [
        {
          input: (
            <Input
              value={
                selectPolicyValue?.discount_rate
                  ? selectPolicyValue?.discount_rate
                  : selectPolicyValue?.discount_rate === 0
                    ? 0
                    : ''
              }
              size="large"
              placeholder="숫자만 입력"
              style={{ ...styles.form.input.medium }}
              onChange={(e) =>
                onChange(
                  'discount_rate',
                  parseInt(Formatter.numberOnly(e.target.value)),
                  selectPolicyValue,
                  setSelectPolicyValue,
                )
              }
              disabled={!(selectCouponValue?.voucher_type !== 'EXCHANGE')}
            />
          ),
        },
        {
          input: (
            <Select
              size="large"
              options={[
                { label: '%', value: 'R' },
                { label: '₩', value: 'W' },
              ]}
              value={
                // policyValue?.discount_type ? policyValue?.discount_type : ''
                selectCouponValue?.voucher_type === 'AMOUNT_DISCOUNT'
                  ? 'W'
                  : selectCouponValue?.voucher_type === 'PERCENT_DISCOUNT'
                    ? 'R'
                    : ''
              }
              disabled
              placeholder="W"
              style={{ ...styles.form.input.medium, width: 80 }}
            />
          ),
        },
      ],
    },
    {
      label: '적립 설정',
      form: [
        {
          input: (
            <Input
              value={
                selectPolicyValue?.reserve_rate
                  ? selectPolicyValue?.reserve_rate
                  : selectPolicyValue?.reserve_rate === 0
                    ? 0
                    : ''
              }
              size="large"
              placeholder="숫자만 입력"
              style={{ ...styles.form.input.medium }}
              onChange={(e) =>
                onChange(
                  'reserve_rate',
                  parseInt(Formatter.numberOnly(e.target.value)),
                  selectPolicyValue,
                  setSelectPolicyValue,
                )
              }
            />
          ),
        },
        {
          input: (
            <Select
              size="large"
              options={[
                { label: '%', value: 'R' },
                { label: '₩', value: 'W' },
              ]}
              value={
                selectPolicyValue?.reserve_type &&
                selectPolicyValue?.reserve_type
              }
              onChange={(e) =>
                onChange(
                  'reserve_type',
                  e,
                  selectPolicyValue,
                  setSelectPolicyValue,
                )
              }
              placeholder="%"
              style={{ ...styles.form.input.medium, width: 80 }}
            />
          ),
        },
      ],
    },
    {
      label: '최대 할인 금액 설정',
      form: [
        {
          input: (
            <>
              <Input
                value={
                  selectPolicyValue?.max_discount_price
                    ? selectPolicyValue?.max_discount_price
                    : selectPolicyValue?.max_discount_price === 0
                      ? 0
                      : ''
                }
                size="large"
                placeholder="숫자만 입력"
                style={{ ...styles.form.input.medium }}
                onChange={(e) =>
                  onChange(
                    'max_discount_price',
                    parseInt(Formatter.numberOnly(e.target.value)),
                    selectPolicyValue,
                    setSelectPolicyValue,
                  )
                }
              />
              <p>원</p>
            </>
          ),
        },
      ],
    },
    {
      label: '수수료율 설정',
      form: [
        {
          input: (
            <>
              <Select
                options={Array.from({ length: 101 }, (_, i) => ({
                  label: i,
                  value: i,
                }))}
                size="large"
                style={{ ...styles.form.input.medium }}
                value={
                  selectPolicyValue?.commission_rate &&
                  selectPolicyValue?.commission_rate
                }
                onChange={(e) =>
                  onChange(
                    'commission_rate',
                    e,
                    selectPolicyValue,
                    setSelectPolicyValue,
                  )
                }
              />
              <p>%</p>
            </>
          ),
        },
      ],
    },
    {
      label: '분담 비율 설정',
      form: [
        {
          input: (
            <>
              <Select
                options={Array.from({ length: 101 }, (_, i) => ({
                  label: i,
                  value: i,
                }))}
                size="large"
                style={{ ...styles.form.input.medium }}
                value={
                  selectPolicyValue?.share_ratio &&
                  selectPolicyValue?.share_ratio
                }
                onChange={(e) =>
                  onChange(
                    'share_ratio',
                    e,
                    selectPolicyValue,
                    setSelectPolicyValue,
                  )
                }
              />
              <p>%</p>
            </>
          ),
        },
      ],
    },
    {
      label: '활성화 여부',
      form: [
        {
          input: (
            <>
              <Radio.Group
                value={selectPolicyValue?.is_show && selectPolicyValue?.is_show}
                onChange={(e) =>
                  onChange(
                    'is_show',
                    e.target.value,
                    selectPolicyValue,
                    setSelectPolicyValue,
                  )
                }
              >
                <Radio value={'Y'}>활성화</Radio>
                <Radio value={'N'}>비활성화</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
  ];

  /**
   * 검색 필터 UI: preset 버튼 onClick 핸들러
   */
  const handlePresetClick = (preset) => {
    const [start, end] = preset === 1 ? ['', ''] : getDateRange(preset);

    setSearchParams((prev) => ({
      ...prev,
      searchDatePreset: preset,
      searchCustomDateRange: { start: start, end: end },
    }));
  };
  /**
   * 페이지 네이션 함수
   * @param {number} page
   * --
   */
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  /* ===== FUNCTION ===== */
  // console.log('userData', userData);
  // console.log('userValue', userValue);
  // 모달 열기 및 위치 설정
  const handleOpenModal = (event, item) => {
    setSelectCouponValue({
      ...item,
      unavailable_store: item?.coupon_content?.unavailable_store,
      note: item?.coupon_content?.note,
      benefit: item?.coupon_content?.benefit,
      standard: item?.coupon_content?.standard,
      start_date: item?.start_date
        ? Formatter.unixToDate(item?.start_date)
        : null,
      end_date: item?.end_date ? Formatter.unixToDate(item?.end_date) : null,
    });
    setSelectPolicyValue(item);
    // setStoreValue(
    //   item?.disabled_shop
    //     ? item?.disabled_shop?.map((item) => ({
    //         ...item,
    //         key: item.shop_information_id,
    //       }))
    //     : []
    // );
    // setMenuValue(
    //   item?.map_menu_policy
    //     ? item?.map_menu_policy?.map((item) => ({
    //         ...item,
    //         key: item.menu_id,
    //       }))
    //     : []
    // );
    setModalPosition({ x: event.clientX, y: event.clientY });
    onOpen(isOpened, 'coupon');
  };

  // 모달 내부 버튼 클릭 핸들러
  const handleOptionClick = (option) => {
    onOpen(false, option);
  };

  /* ===== HOOKS ===== */
  useEffect(() => {
    if (modalType === 'menu_edit') {
      // 메뉴 값 동기화
      setMenuValue(
        selectCouponValue?.map_menu_policy
          ?.filter((menu) => menu.is_enable === 'Y')
          ?.map((menu) => ({
            ...menu,
            key: menu.menu_id,
            ...menuData.find((m) => m.menu_id === menu.menu_id),
          })) || [],
      );
    }
    if (modalType === 'store_edit') {
      // 스토어 값 동기화
      setStoreValue(
        selectCouponValue?.disabled_shop?.map((shop) => ({
          ...shop,
          key: shop.shop_information_id,
        })) || [],
      );
    }
    if (modalType === 'product_edit') {
      // 상품 값 동기화
      setMenuValue(
        selectCouponValue?.map_product_policy
          ?.filter((menu) => menu.is_enable === 'Y')
          ?.map((menu) => ({
            ...menu,
            key: menu.product_id,
            ...menuData.find((m) => {
              return m.product_id === menu.product_id;
            }),
          })) || [],
      );
    }
  }, [modalType, selectCouponValue, menuData]);

  const columns = React.useMemo(() => {
    return [
      {
        title: 'no',
        key: 'user_id',
        dataIndex: 'user_id',
        fixed: 'left',
        sorter: (a, b) => a?.user_id - b?.user_id,
      },
      {
        title: '이름',
        key: 'user_name',
        dataIndex: 'user_name',
        fixed: 'left',
        width: 100,
        ...getColumnSearchProps('user_name'),
      },
      {
        title: '아이디',
        key: 'user_account',
        dataIndex: 'user_account',
        ...getColumnSearchProps('user_account'),
      },
      {
        title: '연락처',
        key: 'user_phone',
        dataIndex: 'user_phone',
        ...getColumnSearchProps('user_phone'),
      },
      {
        title: '이메일',
        key: 'user_email',
        dataIndex: 'user_email',
        ...getColumnSearchProps('user_email'),
      },
      {
        title: '등급',
        key: 'grade',
        dataIndex: 'grade',
        render: (item) => (item ? item : '-'),
        width: 150,
        filters: grades?.map((_item) => ({
          text: _item?.grade_name,
          value: _item?.grade_id,
        })),
        onFilter: (value, record) => record?.grade_id === value,
      },
      {
        title: '성별',
        key: 'user_gender',
        dataIndex: 'user_gender',
      },
      {
        title: '나이',
        key: 'age',
        dataIndex: 'age',
        render: (item) => (item ? item : '-'),
        sorter: (a, b) => a?.age - b?.age,
      },
      {
        title: '지역',
        key: 'user_address',
        width: 300,
        dataIndex: 'user_address',
      },
      {
        title: '회원가입일',
        key: 'created_at',
        dataIndex: 'created_at',
        render: (item) => Formatter.unixToDate(item, 'YYYY-MM-DD'),
        sorter: (a, b) => a?.created_at - b?.created_at,
      },
      {
        title: '계정상태',
        key: 'account_status',
        dataIndex: 'account_status',
        render: (item) => (
          <Tag color={ACCOUNT_STATUS[item]?.color}>
            {ACCOUNT_STATUS[item]?.title}
          </Tag>
        ),
        filters: Object.entries(ACCOUNT_STATUS)?.map(([key, value]) => ({
          text: value?.title,
          value: key,
        })),
        onFilter: (value, record) => record?.account_status === value,
      },
      {
        title: '사업자여부',
        key: 'business_level',
        dataIndex: 'business_level',
        render: (item) => (item === 2 ? 'Y' : 'N'),
        filters: [
          {
            text: '사업자',
            value: 2,
          },
          {
            text: '일반',
            value: 0,
          },
        ],
        onFilter: (value, record) =>
          value === 2
            ? record?.business_level === 2
            : record?.business_level !== 2,
      },
    ];
  }, [grades, ACCOUNT_STATUS]);

  const sideColumns = [
    {
      title: '쿠폰명',
      key: 'coupon_name',
      dataIndex: 'coupon_name',
      ...getColumnSearchProps('coupon_name'),
    },
    {
      title: '쿠폰코드',
      key: 'coupon_code',
      dataIndex: 'coupon_code',
      ...getColumnSearchProps('coupon_code'),
    },
    {
      title: '시작일',
      key: 'start_date',
      dataIndex: 'start_date',
      render: (item) =>
        item ? moment(Formatter.unixToDate(item)).format('YYYY-MM-DD') : '-',
      sorter: (a, b) => a.start_date - b.start_date,
    },
    {
      title: '종료일',
      key: 'end_date',
      dataIndex: 'end_date',
      render: (item) =>
        item ? moment(Formatter.unixToDate(item)).format('YYYY-MM-DD') : '-',
      sorter: (a, b) => a.end_date - b.end_date,
    },
  ];

  /**
   * 쿠폰 데이터 중복 제거
   * --
   */
  const uniqueCoupons = React.useMemo(() => {
    const map = new Map();
    couponData?.forEach((item) => {
      if (!map.has(item.coupon_id)) {
        map.set(item.coupon_id, item);
      }
    });
    return [...map.values()];
  }, [couponData]);

  const progressCoupons = React.useMemo(() => {
    // 진행중인 쿠폰만 필터
    const filtered = uniqueCoupons?.filter((item) => {
      const { start_date = 0, end_date = Infinity } = item;

      return start_date < Formatter.dateToUnix(today) &&
        end_date > Formatter.dateToUnix(today)
        ? true
        : false;
    });

    // 검색된 쿠폰 필터
    const arr = filtered?.filter((item) => {
      // if (item?.payment_type === 'STAMP') {
      //   return true;
      // }
      // if (
      //   item?.payment_type === 'MANUAL' &&
      //   item?.expiration_type === 'ROLLING' &&
      //   item?.is_show === 'Y'
      // ) {
      //   return true;
      // }

      const { process_coupon_name, process_coupon_code } = sideSearchParams;

      if (process_coupon_name)
        return item?.coupon_name?.includes(process_coupon_name);

      if (process_coupon_code)
        return item?.coupon_code?.includes(process_coupon_code);

      return true;
    });

    return arr;
    // eslint-disable-next-line
  }, [
    uniqueCoupons,
    sideSearchParams.expired_coupon_name,
    sideSearchParams.expired_coupon_code,
  ]);

  /**
   * 만료된 쿠폰 목록 추출
   * --
   */
  const expiredCoupons = React.useMemo(() => {
    const arr = uniqueCoupons?.filter((item) => {
      // if (item?.payment_type === 'STAMP') {
      //   return false;
      // }

      // if (
      //   item?.payment_type === 'MANUAL' &&
      //   item?.expiration_type === 'ROLLING' &&
      //   item?.is_show === 'Y'
      // ) {
      //   return false;
      // }

      const { end_date } = item;

      if (!end_date) return false;

      const { expired_coupon_name, expired_coupon_code } = sideSearchParams;

      if (expired_coupon_name)
        return item?.coupon_name?.includes(expired_coupon_name);

      if (expired_coupon_code)
        return item?.coupon_code?.includes(expired_coupon_code);

      return item?.end_date < Formatter.dateToUnix(today);
    });

    return arr;
    // eslint-disable-next-line
  }, [
    uniqueCoupons,
    sideSearchParams.expired_coupon_name,
    sideSearchParams.expired_coupon_code,
  ]);

  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title style={{ ...styles.title }}>쿠폰 목록</Title>

          {/* 요약 */}
          <Content
            maxWidth={'100%'}
            padding={0}
            backgroundColor={'none'}
            style={{ marginBottom: 40 }}
          >
            <Row gutter={20}>
              <Col x={12}>
                <Content maxWidth={'100%'} padding={0} backgroundColor="none">
                  <div>
                    <div
                      style={{
                        padding: '10px 16px',
                        background: '#E1E2E4',
                        borderTopRightRadius: 4,
                        borderTopLeftRadius: 4,
                      }}
                    >
                      <h4 style={{ fontSize: 13, fontWeight: 500 }}>
                        진행중인 쿠폰 {progressCoupons?.length} 건
                      </h4>
                    </div>
                    <div
                      style={{
                        borderBottomLeftRadius: 4,
                        borderBottomRightRadius: 4,
                        background: '#FFFFFF',
                      }}
                    >
                      <AntTable
                        minHeight={260}
                        layoutStyle={{ height: 400 }}
                        onRow={(record) => ({
                          onClick: (event) => handleOpenModal(event, record),
                        })}
                        onRowEvent={true}
                        columns={sideColumns}
                        dataSource={progressCoupons}
                        size="small"
                      />
                    </div>
                  </div>
                </Content>
              </Col>
              <Col x={12}>
                <Content maxWidth={'100%'} padding={0} backgroundColor="none">
                  <div>
                    <div
                      style={{
                        padding: '10px 16px',
                        background: '#E1E2E4',
                        borderTopRightRadius: 4,
                        borderTopLeftRadius: 4,
                      }}
                    >
                      <h4 style={{ fontSize: 13, fontWeight: 500 }}>
                        만료된 쿠폰 {expiredCoupons?.length} 건
                      </h4>
                    </div>
                    <div
                      style={{
                        borderBottomLeftRadius: 4,
                        borderBottomRightRadius: 4,
                        background: '#FFFFFF',
                      }}
                    >
                      <AntTable
                        minHeight={260}
                        layoutStyle={{ height: 400 }}
                        columns={sideColumns}
                        dataSource={expiredCoupons}
                        empty={
                          <p style={{ fontSize: 13, fontWeight: 400 }}>
                            만료된 쿠폰이 없습니다.
                          </p>
                        }
                        size="small"
                      />
                    </div>
                  </div>
                </Content>
              </Col>
            </Row>
          </Content>
          {/* 요약 끝 */}

          {/* 검색필터 */}
          <Content
            maxWidth={'100%'}
            padding={0}
            backgroundColor={'none'}
            style={{ marginBottom: 40 }}
          >
            <ExpandableContainer borderRadius={4} padding={20}>
              {formItem.map((_item, _index) => (
                <div
                  key={`form_${_index}`}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '10px 0px',
                  }}
                >
                  <div style={{ width: 120, fontSize: 13, fontWeight: 400 }}>
                    <label>{_item.label}</label>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {_item.form.map((_subitem, _subkey) => (
                      <React.Fragment key={`input_${_subkey}`}>
                        {_subitem.input}
                      </React.Fragment>
                    ))}
                  </div>
                </div>
              ))}
            </ExpandableContainer>

            {/* 검색/초기화 버튼 */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                marginTop: 48,
              }}
            >
              <Button
                size="large"
                type="primary"
                style={{ ...styles.button, background: 'var(--primary-color)' }}
                onClick={handleSearch}
              >
                검색
              </Button>
              <Button
                size="large"
                style={{ ...styles.button }}
                onClick={handleReset}
              >
                초기화
              </Button>
            </div>
            {/* 검색/초기화 버튼 끝 */}
          </Content>
          {/* 검색필터 끝 */}

          {/* 검색결과 */}
          <Content maxWidth={'100%'} borderRadius={4} padding={20}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: 20,
                justifyContent: 'space-between',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <h4 style={{ fontSize: 14, fontWeight: 500, marginRight: 20 }}>
                  총 <span>{couponData?.length}</span>건
                </h4>
                <Button
                  size="large"
                  style={{ marginRight: 8 }}
                  onClick={() => navigate('/coupon/register/menu')}
                >
                  메뉴 쿠폰 추가
                </Button>
                <Button
                  size="large"
                  style={{ marginRight: 8 }}
                  onClick={() => navigate('/coupon/register/product')}
                >
                  상품 쿠폰 추가
                </Button>
              </div>
            </div>
            <Table
              data={
                filteredCouponData &&
                filteredCouponData?.slice(
                  (currentPage - 1) * ITEMS_PER_PAGE,
                  currentPage * ITEMS_PER_PAGE,
                )
              }
              onRow={handleOpenModal}
              onRowEvent={true}
              columns={[
                {
                  title: '쿠폰명',
                  key: 'coupon_name',
                },
                {
                  title: '쿠폰코드',
                  key: 'coupon_code',
                },
                {
                  title: '발급수량',
                  key: 'coupon_issue_num',
                },
                {
                  title: '할인 수치',
                  key: 'discount',
                  render: (item) =>
                    `${item?.discount_rate} ${
                      item?.discount_type === 'R' ? '%' : '원'
                    }`,
                },
                {
                  title: '적립 수치',
                  key: 'reserve',
                  render: (item) =>
                    `${item?.reserve_rate} ${
                      item?.reserve_type === 'R' ? '%' : '원'
                    }`,
                },
                {
                  title: '쿠폰타입',
                  key: 'coupon_type',
                  render: (item) => (
                    <Tag color={COUPON_TYPE[item]?.color}>
                      {COUPON_TYPE[item]?.label}
                    </Tag>
                  ),
                },
                {
                  title: '발급유형',
                  key: 'voucher_type',
                  render: (item) => (
                    <Tag color={VOUCHER_TYPE[item]?.color}>
                      {VOUCHER_TYPE[item]?.label}
                    </Tag>
                  ),
                },
                {
                  title: '분담비율',
                  key: 'share_ratio',
                },
                {
                  title: '활성화여부',
                  key: 'is_show',
                  render: (item) => IS_VALUE[item]?.['IS_SHOW']?.label,
                },
                {
                  title: '사용처리여부',
                  key: 'is_used',
                  render: (item) => IS_VALUE[item]?.['IS_USED']?.label,
                },
                {
                  title: '쿠폰 시작일',
                  key: 'start_date',
                  render: (item) =>
                    item
                      ? moment(Formatter.unixToDate(item)).format('YYYY-MM-DD')
                      : '-',
                },
                {
                  title: '쿠폰 종료일',
                  key: 'end_date',
                  render: (item) =>
                    item
                      ? moment(Formatter.unixToDate(item)).format('YYYY-MM-DD')
                      : '-',
                },
                // {
                //   title: '비고',
                //   key: '비고',
                //   render: (_, record) => (
                //     <>
                //       {auth[2] === 'U' && (
                //         <Button
                //           size="small"
                //           style={{
                //             borderColor: 'var(--primary-color)',
                //             color: 'var(--primary-color)',
                //             marginRight: 4,
                //           }}
                //           onClick={() => {
                //             onOpen(isOpened, 'admin', {
                //               ...record,
                //               created_at: record?.created_at
                //                 ? Formatter.unixToDate(
                //                     record?.created_at,
                //                     'YYYY-MM-DD'
                //                   )
                //                 : null,
                //               updated_at: record?.updated_at
                //                 ? Formatter.unixToDate(
                //                     record?.updated_at,
                //                     'YYYY-MM-DD'
                //                   )
                //                 : null,
                //             });
                //           }}
                //         >
                //           수정
                //         </Button>
                //       )}
                //     </>
                //   ),
                // },
              ]}
              pagination={false}
            />
            <Pagination
              current={currentPage}
              total={filteredCouponData?.length || 0}
              pageSize={ITEMS_PER_PAGE}
              onChange={handlePageChange}
              showPage={10}
              style={{ marginTop: 40 }}
            />
          </Content>
          {/* 검색결과 끝 */}
        </Col>
      </Row>

      <ModalLayout
        type="modal"
        centered
        title={
          selectCouponValue?.coupon_name
            ? `쿠폰명: ${selectCouponValue?.coupon_name}`
            : ''
        }
        open={isOpened && modalType === 'coupon'}
        style={{
          position: 'absolute',
          top: modalPosition.y, // 모달 위치
          left: modalPosition.x,
        }}
        onCancel={() => onOpen(isOpened)}
        width={'30%'}
      >
        <Content maxWidth={'100%'} padding={0}>
          <div>
            <Row>
              <Col x={24}>
                <Content
                  maxWidth={'100%'}
                  padding={0}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 10,
                  }}
                >
                  <Button onClick={() => handleOptionClick('coupon_edit')}>
                    쿠폰 수정
                  </Button>
                  <Button onClick={() => handleOptionClick('policy_edit')}>
                    할인 수정
                  </Button>

                  {selectCouponValue?.coupon_type !== 'PRODUCT' ? (
                    <Button onClick={() => handleOptionClick('store_edit')}>
                      불가능한 매장 수정
                    </Button>
                  ) : null}

                  {selectCouponValue?.coupon_type !== 'ALL' ? (
                    <Button
                      onClick={() =>
                        handleOptionClick(
                          selectCouponValue?.coupon_type !== 'PRODUCT'
                            ? 'menu_edit'
                            : 'product_edit',
                        )
                      }
                    >
                      {selectCouponValue?.coupon_type !== 'PRODUCT'
                        ? '메뉴 수정'
                        : '상품 수정'}
                    </Button>
                  ) : null}
                </Content>
                <Content
                  maxWidth={'100%'}
                  padding={20}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 10,
                  }}
                >
                  <Button
                    type="primary"
                    onClick={() => handleOptionClick('admin_coupon')}
                  >
                    관리자 발급
                  </Button>
                </Content>
              </Col>
            </Row>
          </div>
        </Content>
      </ModalLayout>

      <ModalLayout
        type="modal"
        centered
        title={'쿠폰 정보'}
        open={isOpened && modalType === 'coupon_edit'}
        onCancel={() => onOpen(isOpened)}
        closable
        width={'50%'}
        footer={
          <Content
            maxWidth={'100%'}
            padding={0}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 10,
            }}
          >
            <Button onClick={() => onOpen(isOpened)}>닫기</Button>
            <Button type="primary" onClick={() => onSubmit('coupon', 'UPDATE')}>
              저장
            </Button>
          </Content>
        }
      >
        <Content maxWidth={'100%'} padding={'30px 0px'}>
          <Row>
            <Col x={24}>
              <CouponInfoForm
                inputValue={selectCouponValue}
                callback={setSelectCouponValue}
                onChange={onChange}
                type={
                  selectCouponValue?.coupon_type === 'PRODUCT'
                    ? 'product'
                    : 'menu'
                }
                style={{ padding: 0 }}
              />
            </Col>
          </Row>
        </Content>
      </ModalLayout>

      <ModalLayout
        type="modal"
        centered
        title={'혜택 정보'}
        open={isOpened && modalType === 'policy_edit'}
        onCancel={() => onOpen(isOpened)}
        closable
        width={'50%'}
        footer={
          <Content
            maxWidth={'100%'}
            padding={0}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 10,
            }}
          >
            <Button onClick={() => onOpen(isOpened)}>닫기</Button>
            <Button type="primary" onClick={() => onSubmit('policy', 'UPDATE')}>
              저장
            </Button>
          </Content>
        }
      >
        <Content maxWidth={'100%'} padding={'30px 0px'}>
          <Row>
            <Col x={24}>
              <Content maxWidth={'100%'} padding={0}>
                <Title style={{ ...styles.subTitle }}>혜택 기본 정보</Title>
                {/* 혜택 기본 정보 */}
                <div style={{ marginTop: 14 }}>
                  <InputFormTable form={policyform} />
                </div>
                {/* 혜택 기본 정보 끝 */}
              </Content>
            </Col>
          </Row>
        </Content>
      </ModalLayout>

      <ModalLayout
        type="modal"
        centered
        title={'불가능한 매장 정보'}
        open={isOpened && modalType === 'store_edit'}
        onCancel={() => onOpen(isOpened)}
        closable
        width={'50%'}
        footer={
          <Content
            maxWidth={'100%'}
            padding={0}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 10,
            }}
          >
            <Button onClick={() => onOpen(isOpened)}>닫기</Button>
            <Button type="primary" onClick={() => onSubmit('store', 'UPDATE')}>
              저장
            </Button>
          </Content>
        }
      >
        <Content maxWidth={'100%'} padding={'30px 0px'}>
          <Row>
            <Col x={24}>
              <Content maxWidth={'100%'} padding={0}>
                <Title style={{ ...styles.subTitle }}>불가능한 매장 선택</Title>
                {`현재 : ${storeValue?.length} 건`}
                {/* 매장 테이블 */}
                <div style={{ marginTop: 14 }}>
                  <Table
                    data={storeData}
                    isChecked
                    columns={[
                      {
                        title: '매장번호',
                        key: 'shop_information_id',
                      },
                      {
                        title: '매장명',
                        key: 'shop_information_name',
                      },
                      {
                        title: '매장설명',
                        key: 'shop_information_content',
                      },
                      {
                        title: '매장 주소',
                        key: 'shop_information_address',
                      },
                      {
                        title: '전화 번호',
                        key: 'business_num',
                      },
                      {
                        title: '매장 타입',
                        key: 'type',
                      },
                    ]}
                    checkedList={storeValue}
                    onChecked={onStoreChecked}
                    checkedAll={isCheckedStoreAll}
                    onCheckedAll={onStoreCheckedAll}
                  />
                </div>
                {/* 매장 테이블 끝 */}
              </Content>
            </Col>
          </Row>
        </Content>
      </ModalLayout>

      <ModalLayout
        type="modal"
        centered
        title={'적용상품 정보'}
        open={
          isOpened &&
          (modalType === 'menu_edit' || modalType === 'product_edit')
        }
        onCancel={() => onOpen(isOpened)}
        closable
        width={'70%'}
        footer={
          <Content
            maxWidth={'100%'}
            padding={0}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 10,
            }}
          >
            <Button onClick={() => onOpen(isOpened)}>닫기</Button>
            <Button
              type="primary"
              onClick={() =>
                onSubmit(
                  modalType === 'menu_edit' ? 'menu' : 'product',
                  'UPDATE',
                )
              }
            >
              저장
            </Button>
          </Content>
        }
      >
        <Content maxWidth={'100%'} padding={'30px 0px'}>
          <Row>
            <Col x={24}>
              <Content maxWidth={'100%'} padding={0}>
                {/* 적용상품 테이블 */}
                <div style={{ marginTop: 14 }}>
                  <CouponProductTable
                    type={modalType === 'menu_edit' ? 'menu' : 'product'}
                    data={menuData}
                    selected={menuValue}
                    onSelect={onSelect}
                    shops={shops}
                    categories={categories?.filter((_item) =>
                      modalType === 'menu_edit'
                        ? _item?.type === 'MENU'
                        : _item?.type === 'PRODUCT',
                    )}
                    style={{ padding: 0 }}
                  />
                </div>
                {/* 적용상품 테이블 끝 */}
              </Content>
            </Col>
          </Row>
        </Content>
      </ModalLayout>

      <Modal
        visible={visible}
        title={'발급수량을 입력해주세요.'}
        centered
        okText={'발급'}
        cancelText={'취소'}
        onOk={() =>
          onSubmit('couponuser', 'CREATE', issuedNumb, () => {
            setIssuedNumb(1);
            setVisible(false);
          })
        }
        onCancel={() => setVisible(false)}
        zIndex={5000}
        afterClose={() => {
          setIssuedNumb(1);
          setVisible(false);
        }}
      >
        <InputNumber
          value={issuedNumb}
          placeholder="발급수량을 입력해주세요."
          onChange={setIssuedNumb}
          min={1}
          style={{ width: '100%' }}
        />
      </Modal>
      <ModalLayout
        type="modal"
        centered
        title={'쿠폰발급'}
        open={isOpened && modalType === 'admin_coupon'}
        onCancel={() => onOpen(isOpened)}
        closable
        width={'80%'}
        footer={
          <Content
            maxWidth={'100%'}
            padding={0}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 10,
            }}
          >
            <Button onClick={() => onOpen(isOpened)}>닫기</Button>
            <Button
              type="primary"
              onClick={() => {
                if (!userValue.length) {
                  MessageAlert.info('회원을 선택해주세요!');
                  return;
                }

                setVisible(!visible);
              }}
            >
              발급
            </Button>
          </Content>
        }
      >
        <Content maxWidth={'100%'} padding={'30px 0px'}>
          <Row>
            <Col x={24}>
              <Content maxWidth={'100%'} padding={0}>
                <Title style={{ ...styles.subTitle }}>회원 선택</Title>
                {/* 적용상품 테이블 */}
                <div style={{ marginTop: 14 }}>
                  <AntTable
                    dataSource={userData}
                    columns={columns}
                    rowSelection={{
                      type: 'checkbox',
                      onSelect: (
                        record,
                        selected,
                        selectedRows,
                        nativeEvent,
                      ) => {
                        onSelect(
                          selected ? 'checked' : 'unchecked',
                          record,
                          userValue,
                          setUserValue,
                        );
                      },
                      onSelectAll: (selected, selectedRows, changeRows) => {
                        onSelect(
                          selected ? 'all-checked' : 'all-unchecked',
                          selectedRows,
                          userValue,
                          setUserValue,
                        );
                      },
                      selectedRowKeys: userValue?.map((_item) => _item?.key),
                    }}
                  />
                </div>
                {/* 적용상품 테이블 끝 */}
              </Content>
            </Col>
          </Row>
        </Content>
      </ModalLayout>
    </Content>
  );
};

export default CouponListPresenter;
